import React from 'react';

import { Chip, useTheme } from '@mui/material';
import { DisplayFilters } from 'src/utils/filters/display-filters';
import {
  getSelectedDietaryTemplateTags,
  toggleTag,
} from 'src/utils/filters/selected-filters';
import RestaurantIcon from 'src/components/Icons/RestaurantIcon';
import { TAG_ICONS_BY_LOGICAL_ID } from '../../constants/tag-icons';

type Props = {
  displayFilters: DisplayFilters;
  selectedFilters: DisplayFilters;
  setSelectedFilters: React.Dispatch<React.SetStateAction<DisplayFilters>>;
};

const DietaryTemplateFilterChips: React.FC<Props> = ({
  displayFilters,
  selectedFilters,
  setSelectedFilters,
}) => {
  const theme = useTheme();

  const dietaryTemplateTags = displayFilters.tagCategories?.find(
    (tc) => tc.logicalId === 'DIETARY_TEMPLATE',
  )?.tags;

  const selectedDietaryTemplateTags = getSelectedDietaryTemplateTags({
    currentFilters: selectedFilters,
  });

  return (
    <>
      {dietaryTemplateTags?.map((dietaryTemplateTag) => {
        const isSelected = selectedDietaryTemplateTags?.find(
          (selectedTag) => selectedTag.id === dietaryTemplateTag.id,
        );
        const iconFill = isSelected
          ? theme.palette.primary.contrastText
          : theme.palette.text.primary;
        const Icon = TAG_ICONS_BY_LOGICAL_ID[dietaryTemplateTag.logicalId];

        return (
          <Chip
            key={dietaryTemplateTag.logicalId}
            label={dietaryTemplateTag.displayName}
            icon={
              Icon ? (
                <Icon fill={iconFill} height={14} width={14} />
              ) : (
                <RestaurantIcon fill={iconFill} height={14} width={14} />
              )
            }
            style={{
              margin: '0 0.35rem 0 0',
              borderRadius: 4,
              fontSize: '0.875rem',
              padding: '6px 8px',
              columnGap: 6,
            }}
            sx={{
              '& .MuiChip-label': { padding: '2px' },
            }}
            size="medium"
            color={isSelected ? 'primary' : 'default'}
            onClick={() => {
              setSelectedFilters((prevState) =>
                toggleTag({
                  displayFilters,
                  currentFilters: prevState,
                  tagId: dietaryTemplateTag.id,
                }),
              );
            }}
          />
        );
      })}
    </>
  );
};

export default DietaryTemplateFilterChips;
